import {loadAssets} from "@/scripts/core/global";

document.addEventListener(
	'DOMContentLoaded',
	function () {
		// instantiate lozad
		loadAssets();
		// accessibility, focus anchor links
		document.addEventListener('keyup', (event) => {
			if (event?.keyCode !== 9 && event?.code !== 'Tab') return;
			document.body.classList.add('a11y');
		});
	},
	false
);
export const trapFocusHandlers: {
	focusin?: (event: FocusEvent) => void;
	focusout?: (event: FocusEvent) => void;
	keydown?: (event: KeyboardEvent) => void;
} = {};
/*document.addEventListener('focusin', function() {
    console.log('focused: ', document.activeElement)
}, true);*/

// local types


